import React, { useEffect, useState } from 'react';
import Link from 'next/link';
import Head from 'next/head';
import getMetaTagData from '../src/common/services/getMetaTagData';
import MainTop from '../src/component/pc/maintop/MainTop';
import MainBottom from '../src/component/pc/MainBottom/MainBottom';
import axios from 'axios';
import moment from 'moment';

function Home ({ metaTagData, jWTCheck }) {
  // 좌우 슬라이더 1 번째 대표 프로그램 bestProgram
  const [bestProgramMaxPageCount, setBestProgramMaxPageCount] = useState(0); // 맥스 카운트값
  const [bestProgram, setBestProgram] = useState(0); // 맥스 카운트값
  const [bestProgramData, setBestProgramData] = useState([]);
  const [bestProgramViewData, setBestProgramViewData] = useState([]);// 현재 나오고있는화면

  // 좌우 슬라이더 2 번째 최신 소식 recentNews
  const [recentNewsMaxPageCount, setRecentNewsMaxPageCount] = useState(0); // 맥스 카운트값
  const [recentNews, setRecentNews] = useState(0);
  const [recentNewsData, setRecentNewsData] = useState([]);
  const [recentNewsViewData, setRecentNewsViewData] = useState([]);// 현재 나오고있는화면

  const [ScrollY, setScrollY] = useState(0); // 스크롤값을 저장하기 위한 상태
  const handleFollow = () => {
    setScrollY(window.pageYOffset); // window 스크롤 값을 ScrollY에 저장
  };

  useEffect(() => {
    // console.log('find data childmild ---->>> ScrollY is ', ScrollY); // ScrollY가 변화할때마다 값을 콘솔에 출력
    if (ScrollY > 10) {
      document.getElementById('wrap').className = 'sbsabout_wrap';
    } else {
      document.getElementById('wrap').className = 'sbsabout_wrap gnb_main';
    }
  }, [ScrollY]);

  useEffect(() => {
    const watch = () => {
      window.addEventListener('scroll', handleFollow);
    };
    watch(); // addEventListener 함수를 실행
    return () => {
      window.removeEventListener('scroll', handleFollow); // addEventListener 함수를 삭제
    };
  }, []);

  const sectionStyle = {
    paddingleft: '0px',
    transform: 'translate3d(0px, 0px, 0px)',
    transition: 'all 0.3s ease-in-out 0s'
  };

  useEffect(() => {
    const config = {
      method: 'get',
      url: 'https://static.cloud.sbs.co.kr/recommend/sbs_programs/main.json',
      timeout: 3000
    };

    axios(config)
      .then(function (response) {
        const addList = [];
        const addList1 = [];

        // title: "그것이 알고싶다"
        // img_url: "http://img2.sbs.co.kr/ops_pgm_img/2021/12/27/02c7fb0d-5843-4add-95b2-ae136ccbec74834w600.jpg"
        // link_url: "http://programs.sbs.co.kr/culture/unansweredquestions"
        const pageCount = parseInt(response.data.list.length / 10);
        setBestProgramMaxPageCount(pageCount);

        for (let i = 0; i < response.data.list.length; i++) {
          const element = response.data.list[i];
          const item = {
            title: element.title,
            img_url: element.img_url,
            link_url: element.link_url
          };

          if (i < 11) { // 초기화면
            addList1.push(item);
          }
          addList.push(item);
        }
        setBestProgramData(addList); // 전체 데이터 담기
        setBestProgramViewData(addList1); // 초기화면 데이터 뿌리기
      })
      .catch(function (error) {
        console.log(error);
      })
      .finally(() => {
      });
  }, []);

  // https://api.board.sbs.co.kr/bbs/V2.0/basic/board/lists?callback=boardListCallback_sbspr_04&offset=0&limit=16&action_type=callback&board_code=sbspr_04&jwt-token=&_=1649656491700
  // 좌우 슬라이더 1 번째 대표 프로그램 bestProgram
  useEffect(() => {
    if (bestProgram === bestProgramMaxPageCount) {
      setBestProgram(0);
    } else if (bestProgram - 1 < -1) {
      setBestProgram(bestProgramMaxPageCount - 1);
    }

    const addList = [];
    for (let index = 0; index < bestProgramData.length; index++) {
      const element = bestProgramData[index];
      const item = {
        title: element.title,
        img_url: element.img_url,
        link_url: element.link_url
      };

      if ((bestProgram === 0) && (index >= 0) && (index < 11)) { // 초기화면
        addList.push(item);
      } else if ((bestProgram === 1) && (index >= 10) && (index < 21)) { // 초기화면
        addList.push(item);
      } else if ((bestProgram === 2) && (index >= 20) && (index < 31)) { // 초기화면
        addList.push(item);
      } else if ((bestProgram === 3) && (index >= 30) && (index < 41)) { // 초기화면
        addList.push(item);
      } else if ((bestProgram === 4) && (index >= 40) && (index < 51)) { // 초기화면
        addList.push(item);
      }
    }
    setBestProgramViewData(addList); // 화면 데이터 뿌리기
  }, [bestProgram]);

  useEffect(() => {
    const config = {
      method: 'get',
      url: 'https://api.board.sbs.co.kr/bbs/V2.0/basic/board/photo/main?callback=boardListCallback_sbspr_01&offset=0&limit=16&action_type=json&menuid=65947',
      timeout: 3000
    };

    axios(config)
      .then(function (response) {
        const addList = [];
        const addList1 = [];

        // "NO": 1488,
        // "PARENT": 0,
        // "DEPTH": 0,
        // "SEQ_INDEX": "000014889999",
        // "TITLE": "[SBS 뉴스토리] 노후 전투기와 청년 조종사",
        // "REG_UNO": "30004216156",
        // "REG_ID": "관리자",
        // "REG_DATE": "2022-04-08 11:39:16",
        // "CLICK_CNT": 15,
        // "RECOMMEND_CNT": 0,
        // "REPLY_CNT": 0,
        // "SYMPATHY_ICON": "",
        // "SYMPATHY_ICON_ALT": "",
        // "BEST_EXCLUDE": "N",
        // "FILE_CNT": 1,
        // "DEVICE_TYPE": "P",
        // "HEAD_TEXT": "",
        // "DELETED": "N",
        // "CONTENT": "<p style=\"list-style: none; margin: 0cm 0cm 0.0001pt; color: rgb(68, 68, 68); font-size: 10pt; font-family: Arial, sans-serif; text-align: center; line-height: 1.8; word-break: keep-all;\" align=\"center\"><b><span style=\"font-size: 14pt; font-family: &quot;맑은 고딕&quot;; margin-top: 0px; margin-bottom: 0px;\">노후 전투기와 청년 조종사</span></b></p><p style=\"list-style: none; margin: 0cm 0cm 0.0001pt; color: rgb(68, 68, 68); font-size: 10pt; font-family: Arial, sans-serif; text-align: center; line-height: 24px; word-break: keep-all;\" align=\"center\"><b><span style=\"font-size: 14pt; font-family: &quot;맑은 고딕&quot;; margin-top: 0px; margin-bottom: 0px;\"><br></span></b></p><div style=\"list-style: none; margin: 0cm 0cm 0.0001pt; color: rgb(68, 68, 68); font-size: 10pt; font-family: Arial, sans-serif; line-height: 24px; word-break: keep-all;\" align=\"center\"><div><div style=\"line-height: 1.8;\" className=\"aba_img_w\" id=\"upload_image_bHp1649385539366.jpg\">      <a title=\"이미지 뷰어 새창 열림\" className=\"ec_imglink_w\" href=\"#none\" target=\"_blank\">          <img alt=\"활짝 웃고 있는 조종사. 하늘에 떠있는 전투기들\" className=\"aba_img\" src=\"//image.board.sbs.co.kr/2022/04/08/bHp1649385539366-850.jpg\"></a></div></div></div><p style=\"list-style: none; margin: 0cm 0cm 0.0001pt; color: rgb(68, 68, 68); text-align: justify; font-size: 10pt; font-family: &quot;맑은 고딕&quot;; line-height: 1.8;\"><span style=\"font-size: 11pt; margin-top: 0px; margin-bottom: 0px;\">지난 1월 11일, 경기도 화성시 한 야산에 전투기 1대가 추락했다. 추락한 전투기에는 공군 제10전투비행단 소속의 조종사 심정민 소령이 타고 있었다. 그의 나이 29살. 그는 비상탈출을 할 수 있었음에도 민가를 피하기 위해 끝까지 조종간을 붙잡았고 결국 현장에서 숨졌다.</span></p><p style=\"list-style: none; margin: 0cm 0cm 0.0001pt; color: rgb(68, 68, 68); text-align: justify; font-size: 10pt; font-family: &quot;맑은 고딕&quot;; line-height: 1.8;\">&nbsp;</p><p style=\"list-style: none; margin: 0cm 0cm 0.0001pt; color: rgb(68, 68, 68); text-align: justify; font-size: 10pt; font-family: &quot;맑은 고딕&quot;; line-height: 1.8;\"><span style=\"font-size: 11pt; margin-top: 0px; margin-bottom: 0px;\">공군에 따르면, 사고가 난 F-5 전투기 우측 엔진의 연료 도관에 머리카락 굵기 정도의 구멍이 2개가 생겼고, 그 구멍 사이로 새어 나온 연료에 불이 붙어 전투기가 추락했다고 밝혔다. 전문가들은 이번 사고의 근본적인 원인으로 사고 전투기 기종인 F-5의 노후화를 한 목소리로 지적했다.</span></p><p style=\"list-style: none; margin: 0cm 0cm 0.0001pt; color: rgb(68, 68, 68); text-align: justify; font-size: 10pt; font-family: &quot;맑은 고딕&quot;; line-height: 1.8;\">&nbsp;</p><p style=\"list-style: none; margin: 0cm 0cm 0.0001pt; color: rgb(68, 68, 68); text-align: justify; font-size: 10pt; font-family: &quot;맑은 고딕&quot;; line-height: 1.8;\"><span style=\"font-size: 11pt; margin-top: 0px; margin-bottom: 0px;\">F-5&nbsp;</span><span style=\"font-size: 11pt; margin-top: 0px; margin-bottom: 0px;\">전투기는 1960년대부터 순차적으로 국내 도입이 시작돼 현재까지 50년 넘게 운용되는 노후 기종이다. 공군은 F-5 전투기의 사용 수명을 당초 31년으로 잡았는데, 이를 3번이나 연장하며 아직도 쓰고 있다. 현재 F-5 조종사들은 자신보다 나이가 많은 노후 기체를 타고 있는 셈이다.</span></p><p style=\"list-style: none; margin: 0cm 0cm 0.0001pt; color: rgb(68, 68, 68); text-align: justify; font-size: 10pt; font-family: &quot;맑은 고딕&quot;; line-height: 1.8;\"><span style=\"font-size: 11pt; margin-top: 0px; margin-bottom: 0px;\">2000</span><span style=\"font-size: 11pt; margin-top: 0px; margin-bottom: 0px;\">년 이후 F-5 전투기 추락 사고로 순직한 조종사는 14명이나 된다. 노후 전투기는 조종사들의 생명뿐만 아니라 일반 시민들의 희생을 낳을 수도 있다. F-5가 배치된 국내 공군기지들은 수원, 강릉 등 도심에 위치해 있다.</span></p><p style=\"list-style: none; margin: 0cm 0cm 0.0001pt; color: rgb(68, 68, 68); text-align: justify; font-size: 10pt; font-family: &quot;맑은 고딕&quot;; line-height: 1.8;\">&nbsp;</p><p style=\"list-style: none; margin: 0cm 0cm 0.0001pt; color: rgb(68, 68, 68); text-align: justify; font-size: 10pt; font-family: &quot;맑은 고딕&quot;; line-height: 1.8;\"><span style=\"font-size: 11pt; margin-top: 0px; margin-bottom: 0px;\">다수의 전문가들은 노후 전투기 F-5를 최대한 빨리 퇴역시켜야 한다고 말한다. F-5를 당장 퇴역시켜도 공군 전력이 약화되진 않을 것이라는 분석이다. 뉴스토리 취재 결과, 공군은 노후 전투기 대체를 위해서 차세대 전투기 확보 사업인 F-X 2차 사업을 재추진하고, 경공격기 FA-50을 추가로 확보할 계획인 것으로 확인됐다.</span></p><p style=\"list-style: none; margin: 0cm 0cm 0.0001pt; color: rgb(68, 68, 68); text-align: justify; font-size: 10pt; font-family: &quot;맑은 고딕&quot;; line-height: 1.8;\">&nbsp;</p><p style=\"list-style: none; margin: 0cm 0cm 0.0001pt; color: rgb(68, 68, 68); text-align: justify; font-size: 10pt; font-family: &quot;맑은 고딕&quot;; line-height: 1.8;\"><span style=\"font-size: 11pt; margin-top: 0px; margin-bottom: 0px;\">이번 주 SBS &lt;뉴스토리&gt;에서는 F-5 전투기 노후화 문제를 진단하고 대안을 모색한다.</span></p>",
        // "CHILD_CNT": 0,
        // "ADMIN_YN": "Y",
        // "BOARD_SEQ": 99,
        // "CATEGORY_NO": 0,
        // "CONTENT_TYPE": "I",
        // "URL": "//image.board.sbs.co.kr/2022/04/08/bHp1649385539366.jpg",
        // "SIZE": 207857,
        // "THUMBNAIL_SIZE": 100,
        // "DESCRIPTION": "활짝 웃고 있는 조종사. 하늘에 떠있는 전투기들",
        // "TYPE": "I",
        // "VR_YN": "N",
        // "SORT": 0,
        // "MEDIA_ID": "",
        // "REPRESENT_YN": "Y",
        // "KEYWORD": "뉴스토리",
        // "CHARACTER_KEYWORD": "",
        // "CHARACTER_CODE": "",
        // "CAPTION": "",
        // "LINK_URL": ""

        const pageCount = parseInt(response.data.length / 3);
        setRecentNewsMaxPageCount(pageCount);
        for (let i = 0; i < response.data.length; i++) {
          const element = response.data[i];
          let img = element.IMG_URL;
          img = img.replace('.jpg', '-cr.jpg');
          // console.log('find data childmild element.IMG_URL =========== ' + element.IMG_URL);
          // console.log('find data childmild cst =========== ' + img);
          const item = {
            title: element.TITLE,
            reg_date: element.REG_DATE,
            img_url: img,
            link_url: element.LINK_URL
          };

          if (i < 4) { // 초기화면
            addList1.push(item);
          }
          addList.push(item);
        }
        setRecentNewsData(addList); // 전체 데이터 담기
        setRecentNewsViewData(addList1); // 초기화면 데이터 뿌리기
      })
      .catch(function (error) {
        console.log(error);
      })
      .finally(() => {
      });
  }, []);

  // 좌우 슬라이더 2 번째 최신소식
  useEffect(() => {
    if (recentNews === recentNewsMaxPageCount) {
      setRecentNews(0);
    } else if (recentNews - 1 < -1) {
      setRecentNews(recentNewsMaxPageCount - 1);
    }

    // title: element.TITLE,
    // reg_date: element.REG_DATE,
    // img_url: element.URL,
    // link_url: element.LINK_URL

    const addList = [];
    for (let index = 0; index < recentNewsData.length; index++) {
      const element = recentNewsData[index];
      const item = {
        title: element.title,
        img_url: element.img_url,
        link_url: element.link_url,
        reg_date: element.reg_date
      };

      if ((recentNews === 0) && (index >= 0) && (index < 4)) {
        addList.push(item);
      } else if ((recentNews === 1) && (index >= 3)) {
        addList.push(item);
      } else if ((recentNews === 2) && (index >= 6) && (index < 10)) {
        addList.push(item);
      } else if ((recentNews === 3) && (index >= 9) && (index < 13)) {
        addList.push(item);
      } else if ((recentNews === 4) && (index >= 12) && (index < 16)) {
        addList.push(item);
      }
    }
    setRecentNewsViewData(addList); // 화면 데이터 뿌리기
  }, [recentNews]);

  // gtag
  useEffect(() => {
    if (process.env.NODE_ENV === 'production') {
      window.dataLayer = window.dataLayer || [];
      function gtag () { dataLayer.push(arguments); }
      gtag('js', new Date());
      gtag('config', 'UA-104756746-1');
      gtag('config', 'G-L9E7Y63ZNE');
    }
  }, []);

  return (
    <>
      <script async src='https://www.googletagmanager.com/gtag/js?id=UA-104756746-1' />
      <Head>
        <link key='css_pc_url' rel='stylesheet' href={process.env.NEXT_PUBLIC_GLOBAL_CSS_PC_URL} />
        <meta key='viewport' name='viewport' content='width=device-width, initial-scale=1' />
        <meta name='description' content="SBS의 대표 프로그램과 서비스 등 30년 히스토리와 최근 소식을 만나보세요!" />
        <meta name='keywords' content={metaTagData.keywords} />
        <meta name='twitter:card' content='summary' />
        <noscript>Your browser does not support JavaScript!</noscript>
        <meta property='og:type' content='website' />
        <meta property='og:locale' content='ko_KR' />
        <meta property='og:site_name' content='SBS' />
        <meta property='og:title' content={'' || ''} />
        <meta property='og:description' content={'SBS의 대표 프로그램과 서비스 등 30년 히스토리와 최근 소식을 만나보세요!' || ''} />
        <meta property='og:image' content={metaTagData.shareImageUrl || ''} />
        <meta property='og:url' content={metaTagData.currentUrl || ''} />
        <meta name='nate:site_name' content='SBS' />
        <meta name='nate:title' content={'' || ''} />
        <meta name='nate:description' content={'SBS의 대표 프로그램과 서비스 등 30년 히스토리와 최근 소식을 만나보세요!' || ''} />
        <meta name='nate:image' content={metaTagData.shareImageUrl || ''} />
        <meta name='nate:url' content={metaTagData.currentUrl || ''} />
        <title>메인 - SBS 소개 : SBS</title>
      </Head>

      <ul id='skip_nav'>
        <li><a href='#container'>본문컨텐츠</a></li>
        <li><a href='#header'>헤더 메뉴</a></li>
      </ul>
      {/*  */}
      <div id='wrap' className='sbsabout_wrap section_main'>

        <MainTop />
        {/* <!-- 컨텐츠영역 --> */}
        <div id='container' className='contents'>
          <h2 className='hide'>SBS</h2>
          {/* <!-- 컨텐츠 --> */}
          <div className='sbsabout_main_w'>
            <div className='sbsabout_main_visual_w'>
              <h3 className='sbsabout_main_vtitle'>
                SBS는 지난 30년간<br />대한민국의 방송 콘텐츠 산업을 이끌어 왔습니다.
              </h3>
            </div>
            <div className='sbsabout_main_inner'>
              <div className='sbsabout_main_cont01'>
                <div className='sbsabout_inner'>
                  <p className='smc_text'>
                    시대가 빠르게 변하고 모두가 위기를 이야기할 때,<br />
                    SBS는 틀을 깨는 새로움으로 <br />
                    시청자에게 기쁨 주고 사랑을 받았습니다.
                  </p>
                </div>
              </div>

              <div className='sbsabout_main_cont02'>
                <div className='sbsabout_inner'>
                  <p className='smc_text'>
                    SBS 예능은 상상의 경계를 뛰어넘는<br />
                    새로운 콘텐츠와 실험적인 도전으로<br />
                    웃음과 감동을 전합니다.
                  </p>
                </div>
              </div>

              <div className='sbsabout_main_cont03'>
                <div className='sbsabout_inner'>
                  <p className='smc_text'>
                    SBS 드라마는 ‘스튜디오S’의 출범과<br />
                    함께 더욱 참신한 기획과<br />
                    과감한 투자로 시청자들에게<br />
                    웰메이드 작품을 선사합니다.
                  </p>
                </div>
              </div>

              <div className='sbsabout_main_cont04'>
                <div className='sbsabout_inner'>
                  <p className='smc_text'>
                    SBS 교양은 색다른 연출과<br />
                    소재 선정으로 시청자들의 신뢰를 받고,<br />
                    시대정신을 구현하기 위해 노력합니다.
                  </p>
                </div>
              </div>

              <div className='sbsabout_main_cont05'>
                <div className='sbsabout_inner'>
                  <p className='smc_text'>
                    SBS 뉴스는 단순한 정보 전달을<br />
                    뛰어넘어 현안을 심층 분석하고<br />
                    시대의 어젠다를 제시하는<br />
                    ‘한 단계 진화된 뉴스’를 선보입니다.
                  </p>
                </div>
              </div>

              <div className='sbsabout_main_cont06'>
                <div className='sbsabout_inner'>
                  <p className='smc_text'>
                    SBS 라디오는 음악과 이야기를 통한<br />
                    적극적인 교감으로 <br />
                    단단한 애청자 층을 만들어 나갑니다.
                  </p>
                </div>
              </div>

              {/* <!-- 프로그램 --> */}
              <div className='sbsabout_main_program'>
                <div className='sbsabout_inner'>
                  <h4 className='module_title_w'>
                    <Link href='/program'>
                      <a className='module_title_link'>
                        <span className='module_title_text'>대표 프로그램</span>
                        <span className='svg_icon_arrow'>
                          <svg width='14.999' height='29.999' viewBox='0 0 14.999 29.999'>
                            <path d='M-11119.531-16160.5a.929.929,0,0,1-.685-.3,1.085,1.085,0,0,1,0-1.463l12.38-13.234-12.38-13.234a1.085,1.085,0,0,1,0-1.463.926.926,0,0,1,1.368,0l13.064,13.967a1.085,1.085,0,0,1,0,1.463l-13.064,13.965A.928.928,0,0,1-11119.531-16160.5Z' transform='translate(11120.499 16190.499)' fill='#fff' />
                          </svg>
                        </span>
                      </a>
                    </Link>
                  </h4>
                  <div className='module_poster_list_w'>
                    <div className='module_poster_list_swipe'>
                      <div className='module_poster_list' style={sectionStyle}>
                        <ul className='module_poster_list_inner'>

                          {bestProgramViewData.map((item, index) => {
                            return (
                              <li key={index} className='module_poster_list_cont'>
                                <div className='post_box_w'>
                                  <a href={item.link_url} className='pb_link'>
                                    <div className='pb_image_w'>
                                      <div className='pb_image_inner'>
                                        <img src={item.img_url} className='pb_image' alt={item.title} />
                                      </div>
                                    </div>
                                    <div className='pb_info_w'>
                                      <span className='pbif_title'>{item.title}</span>
                                    </div>
                                  </a>
                                </div>
                              </li>
                            );
                          })}

                        </ul>

                      </div>
                      {/* <!-- max 5개 --> */}
                      <ul className='slide_dots_w'>
                        {bestProgramMaxPageCount >= 1 ? (<li className={`slide_dots ${bestProgram === 0 ? 'current' : ''}`}><i className='hide'>첫번째 페이지</i></li>) : (<div />)}
                        {bestProgramMaxPageCount >= 2 ? (<li className={`slide_dots ${bestProgram === 1 ? 'current' : ''}`}><i className='hide'>두번째 페이지</i></li>) : (<div />)}
                        {bestProgramMaxPageCount >= 3 ? (<li className={`slide_dots ${bestProgram === 2 ? 'current' : ''}`}><i className='hide'>세번째 페이지</i></li>) : (<div />)}
                        {bestProgramMaxPageCount >= 4 ? (<li className={`slide_dots ${bestProgram === 3 ? 'current' : ''}`}><i className='hide'>네번째 페이지</i></li>) : (<div />)}
                        {bestProgramMaxPageCount >= 5 ? (<li className={`slide_dots ${bestProgram === 4 ? 'current' : ''}`}><i className='hide'>다섯번째 페이지</i></li>) : (<div />)}
                      </ul>
                    </div>
                    <button keydown={() => { setBestProgram(bestProgram - 1); }} onClick={() => { setBestProgram(bestProgram - 1); }} className='slide_button_prev'>
                      <span className='sb_inner'>
                        <span className='sb_paging'><i className='sbp_active'>{bestProgram + 1}</i>/<i className='sbp_all'>{bestProgramMaxPageCount}</i></span>
                        <span className='sb_icon'>
                          <svg xmlns='http://www.w3.org/2000/svg' width='10' height='20' viewBox='0 0 12.414 22.828'><path d='M-11109.5-16189.5l-10,10,10,10' transform='translate(11120.5 16190.914)' /></svg>
                          <i className='hide'>이전</i>
                        </span>
                      </span>
                    </button>
                    <button keydown={() => { setBestProgram(bestProgram + 1); }} onClick={() => { setBestProgram(bestProgram + 1); }} className='slide_button_next'>
                      <span className='sb_inner'>
                        <span className='sb_paging'><i className='sbp_active'>{bestProgram + 1}</i>/<i className='sbp_all'>{bestProgramMaxPageCount}</i></span>
                        <span className='sb_icon'>
                          <svg xmlns='http://www.w3.org/2000/svg' width='10' height='20' viewBox='0 0 12.414 22.828'><path d='M-11109.5-16189.5l-10,10,10,10' transform='translate(11120.5 16190.914)' /></svg>
                          <i className='hide'>다음</i>
                        </span>
                      </span>
                    </button>
                  </div>
                </div>
              </div>

              {/* <!-- 플랫폼소개 --> */}
              <div className='sbsabout_main_platform'>
                <div className='sbsabout_inner'>
                  <h4 className='module_title_w'>
                    <Link href='/platform'>
                      <a className='module_title_link'>
                        <span className='module_title_text'>플랫폼 소개</span>
                        <span className='svg_icon_arrow'>
                          <svg width='14.999' height='29.999' viewBox='0 0 14.999 29.999'>
                            <path d='M-11119.531-16160.5a.929.929,0,0,1-.685-.3,1.085,1.085,0,0,1,0-1.463l12.38-13.234-12.38-13.234a1.085,1.085,0,0,1,0-1.463.926.926,0,0,1,1.368,0l13.064,13.967a1.085,1.085,0,0,1,0,1.463l-13.064,13.965A.928.928,0,0,1-11119.531-16160.5Z' transform='translate(11120.499 16190.499)' fill='#fff' />
                          </svg>
                        </span>
                      </a>
                    </Link>
                  </h4>
                  <div className='platform_list_w'>
                    <ul className='platform_list_inner'>
                      <li className='platform_list_cont'>
                        <Link href='https://www.sbs.co.kr/'>
                          <a className='platform_list_link'>
                            <div className='platform_image_w'>
                              <div className='platform_image_inner'>
                                <img src='styles/2022/pc/img/sbs_web.png' alt='sbs web' className='platform_image' />
                              </div>
                            </div>
                            <div className='platform_text_w'>
                              <strong className='pt_title'>sbs.co.kr</strong>
                              <span className='pt_value'>Website</span>
                              <span className='pt_round'>
                                <span className='pt_arrow'>
                                  <svg width='10' height='6' viewBox='0 0 10 6'>
                                    <path d='M3.974,5a.822.822,0,0,1-.591-.253L-.758.461a.875.875,0,0,1,0-1.212.817.817,0,0,1,1.178,0L3.978,2.931l3.6-3.682a.817.817,0,0,1,1.179,0,.875.875,0,0,1,0,1.212L4.561,4.751A.822.822,0,0,1,3.974,5Z' transform='translate(1 1)' fill='#fff' />
                                  </svg>
                                  <i className='hide'>페이지 이동</i>
                                </span>
                              </span>
                            </div>
                          </a>
                        </Link>
                      </li>
                      <li className='platform_list_cont'>
                        <Link href='https://play.google.com/store/apps/details?id=kr.co.sbs.videoplayer'>
                          <a className='platform_list_link'>
                            <div className='platform_logo_w'>
                              <img src='styles/2022/pc/img/sbs_app_icon.png' alt='sbs아이콘' className='logo_image' />
                            </div>
                            <div className='platform_image_w'>
                              <div className='platform_image_inner'>
                                <img src='styles/2022/pc/img/sbs_app.png' alt='sbs app' className='platform_image' />
                              </div>
                            </div>
                            <div className='platform_text_w'>
                              <strong className='pt_title'>SBS</strong>
                              <span className='pt_value'>App</span>
                              <span className='pt_round'>
                                <span className='pt_arrow'>
                                  <svg width='10' height='6' viewBox='0 0 10 6'>
                                    <path d='M3.974,5a.822.822,0,0,1-.591-.253L-.758.461a.875.875,0,0,1,0-1.212.817.817,0,0,1,1.178,0L3.978,2.931l3.6-3.682a.817.817,0,0,1,1.179,0,.875.875,0,0,1,0,1.212L4.561,4.751A.822.822,0,0,1,3.974,5Z' transform='translate(1 1)' fill='#fff' />
                                  </svg>
                                  <i className='hide'>페이지 이동</i>
                                </span>
                              </span>
                            </div>
                          </a>
                        </Link>
                      </li>
                      <li className='platform_list_cont'>
                        <Link href='https://play.google.com/store/apps/details?id=com.appgate.gorealra'>
                          <a className='platform_list_link'>
                            <div className='platform_logo_w'>
                              <img src='styles/2022/pc/img/goreala_app_icon.png' alt='고릴라앱 아이콘' className='logo_image' />
                            </div>
                            <div className='platform_image_w'>
                              <div className='platform_image_inner'>
                                <img src='styles/2022/pc/img/goreala_app.png' alt='고릴라앱' className='platform_image' />
                              </div>
                            </div>
                            <div className='platform_text_w'>
                              <strong className='pt_title'>SBS 고릴라</strong>
                              <span className='pt_value'>App</span>
                              <span className='pt_round'>
                                <span className='pt_arrow'>
                                  <svg width='10' height='6' viewBox='0 0 10 6'>
                                    <path d='M3.974,5a.822.822,0,0,1-.591-.253L-.758.461a.875.875,0,0,1,0-1.212.817.817,0,0,1,1.178,0L3.978,2.931l3.6-3.682a.817.817,0,0,1,1.179,0,.875.875,0,0,1,0,1.212L4.561,4.751A.822.822,0,0,1,3.974,5Z' transform='translate(1 1)' fill='#fff' />
                                  </svg>
                                  <i className='hide'>페이지 이동</i>
                                </span>
                              </span>
                            </div>
                          </a>
                        </Link>
                      </li>
                      <li className='platform_list_cont'>
                        <Link href='https://play.google.com/store/apps/details?id=com.cubeflux.news&hl=ko&gl=US'>
                          <a className='platform_list_link'>
                            <div className='platform_logo_w'>
                              <img src='styles/2022/pc/img/sbsnews_app_icon.png' alt='SBS뉴스 앱 아이콘' className='logo_image' />
                            </div>
                            <div className='platform_image_w'>
                              <div className='platform_image_inner'>
                                <img src='styles/2022/pc/img/sbsnews_app.png' alt='sbs뉴스앱' className='platform_image' />
                              </div>
                            </div>
                            <div className='platform_text_w'>
                              <strong className='pt_title'>SBS NEWS</strong>
                              <span className='pt_value'>App</span>
                              <span className='pt_round'>
                                <span className='pt_arrow'>
                                  <svg width='10' height='6' viewBox='0 0 10 6'>
                                    <path d='M3.974,5a.822.822,0,0,1-.591-.253L-.758.461a.875.875,0,0,1,0-1.212.817.817,0,0,1,1.178,0L3.978,2.931l3.6-3.682a.817.817,0,0,1,1.179,0,.875.875,0,0,1,0,1.212L4.561,4.751A.822.822,0,0,1,3.974,5Z' transform='translate(1 1)' fill='#fff' />
                                  </svg>
                                  <i className='hide'>페이지 이동</i>
                                </span>
                              </span>
                            </div>
                          </a>
                        </Link>
                      </li>
                      <li className='platform_list_cont'>
                        <Link href='https://play.google.com/store/apps/details?id=com.confitech.sbsgolf&hl=ko&gl=US'>
                          <a className='platform_list_link'>
                            <div className='platform_logo_w'>
                              <img src='styles/2022/pc/img/sbsgolf_app_icon.png' alt='sbs골프 앱 아이콘' className='logo_image' />
                            </div>
                            <div className='platform_image_w'>
                              <div className='platform_image_inner'>
                                <img src='styles/2022/pc/img/sbsgolf_app.png' alt='sbs골프' className='platform_image' />
                              </div>
                            </div>
                            <div className='platform_text_w'>
                              <strong className='pt_title'>SBS 골프</strong>
                              <span className='pt_value'>App</span>
                              <span className='pt_round'>
                                <span className='pt_arrow'>
                                  <svg width='10' height='6' viewBox='0 0 10 6'>
                                    <path d='M3.974,5a.822.822,0,0,1-.591-.253L-.758.461a.875.875,0,0,1,0-1.212.817.817,0,0,1,1.178,0L3.978,2.931l3.6-3.682a.817.817,0,0,1,1.179,0,.875.875,0,0,1,0,1.212L4.561,4.751A.822.822,0,0,1,3.974,5Z' transform='translate(1 1)' fill='#fff' />
                                  </svg>
                                  <i className='hide'>페이지 이동</i>
                                </span>
                              </span>
                            </div>
                          </a>
                        </Link>
                      </li>
                      <li className='platform_list_cont'>
                        <Link href='https://play.google.com/store/apps/details?id=kr.co.sbs.cnbc&hl=ko&gl=US'>
                          <a className='platform_list_link'>
                            <div className='platform_logo_w'>
                              <img src='styles/2022/pc/img/sbsbiz_app_icon.png' alt='sbs biz 앱 아이콘' className='logo_image' />
                            </div>
                            <div className='platform_image_w'>
                              <div className='platform_image_inner'>
                                <img src='styles/2022/pc/img/sbsbiz_app.png' alt='sbs biz 앱' className='platform_image' />
                              </div>
                            </div>
                            <div className='platform_text_w'>
                              <strong className='pt_title'>SBS Biz</strong>
                              <span className='pt_value'>App</span>
                              <span className='pt_round'>
                                <span className='pt_arrow'>
                                  <svg width='10' height='6' viewBox='0 0 10 6'>
                                    <path d='M3.974,5a.822.822,0,0,1-.591-.253L-.758.461a.875.875,0,0,1,0-1.212.817.817,0,0,1,1.178,0L3.978,2.931l3.6-3.682a.817.817,0,0,1,1.179,0,.875.875,0,0,1,0,1.212L4.561,4.751A.822.822,0,0,1,3.974,5Z' transform='translate(1 1)' fill='#fff' />
                                  </svg>
                                  <i className='hide'>페이지 이동</i>
                                </span>
                              </span>
                            </div>
                          </a>
                        </Link>
                      </li>
                      <li className='platform_list_cont'>
                        <Link href='https://play.google.com/store/apps/details?id=kr.co.sbs.tpod&hl=ko&gl=US'>
                          <a className='platform_list_link'>
                            <div className='platform_logo_w'>
                              <img src='styles/2022/pc/img/tpod_app_icon.png' alt='tbod앱 아이콘' className='logo_image' />
                            </div>
                            <div className='platform_image_w'>
                              <div className='platform_image_inner'>
                                <img src='styles/2022/pc/img/tpod_app.png' alt='tbod앱' className='platform_image' />
                              </div>
                            </div>
                            <div className='platform_text_w'>
                              <strong className='pt_title'>티팟</strong>
                              <span className='pt_value'>App</span>
                              <span className='pt_round'>
                                <span className='pt_arrow'>
                                  <svg width='10' height='6' viewBox='0 0 10 6'>
                                    <path d='M3.974,5a.822.822,0,0,1-.591-.253L-.758.461a.875.875,0,0,1,0-1.212.817.817,0,0,1,1.178,0L3.978,2.931l3.6-3.682a.817.817,0,0,1,1.179,0,.875.875,0,0,1,0,1.212L4.561,4.751A.822.822,0,0,1,3.974,5Z' transform='translate(1 1)' fill='#fff' />
                                  </svg>
                                  <i className='hide'>페이지 이동</i>
                                </span>
                              </span>
                            </div>
                          </a>
                        </Link>
                      </li>
                      <li className='platform_list_cont'>
                        <Link href='https://allvod.sbs.co.kr/allvod/vodMain.do?div=gnb_pc'>
                          <a className='platform_list_link'>
                            <div className='platform_image_w'>
                              <div className='platform_image_inner'>
                                <img src='styles/2022/pc/img/allvod_web.png' alt='allvod 앱' className='platform_image' />
                              </div>
                            </div>
                            <div className='platform_text_w'>
                              <strong className='pt_title'>ALLVOD</strong>
                              <span className='pt_value'>WEBSITE</span>
                              <span className='pt_round'>
                                <span className='pt_arrow'>
                                  <svg width='10' height='6' viewBox='0 0 10 6'>
                                    <path d='M3.974,5a.822.822,0,0,1-.591-.253L-.758.461a.875.875,0,0,1,0-1.212.817.817,0,0,1,1.178,0L3.978,2.931l3.6-3.682a.817.817,0,0,1,1.179,0,.875.875,0,0,1,0,1.212L4.561,4.751A.822.822,0,0,1,3.974,5Z' transform='translate(1 1)' fill='#fff' />
                                  </svg>
                                  <i className='hide'>ALL VOD</i>
                                </span>
                              </span>
                            </div>
                          </a>
                        </Link>
                      </li>
                      <li className='platform_list_cont'>
                        <Link href='https://matstar.sbs.co.kr/main.html?div=gnb_pc'>
                          <a className='platform_list_link'>
                            <div className='platform_image_w'>
                              <div className='platform_image_inner'>
                                <img src='styles/2022/pc/img/foodstar_web.png' alt='tv맛집 앱' className='platform_image' />
                              </div>
                            </div>
                            <div className='platform_text_w'>
                              <strong className='pt_title'>TV맛집</strong>
                              <span className='pt_value'>WEBSITE</span>
                              <span className='pt_round'>
                                <span className='pt_arrow'>
                                  <svg width='10' height='6' viewBox='0 0 10 6'>
                                    <path d='M3.974,5a.822.822,0,0,1-.591-.253L-.758.461a.875.875,0,0,1,0-1.212.817.817,0,0,1,1.178,0L3.978,2.931l3.6-3.682a.817.817,0,0,1,1.179,0,.875.875,0,0,1,0,1.212L4.561,4.751A.822.822,0,0,1,3.974,5Z' transform='translate(1 1)' fill='#fff' />
                                  </svg>
                                  <i className='hide'>페이지 이동</i>
                                </span>
                              </span>
                            </div>
                          </a>
                        </Link>
                      </li>
                      <li className='platform_list_cont'>
                        <Link href='https://star.sbs.co.kr/main/index.html?div=gnb_pc'>
                          <a className='platform_list_link'>
                            <div className='platform_image_w'>
                              <div className='platform_image_inner'>
                                <img src='styles/2022/pc/img/star_web.png' alt='star 웹' className='platform_image' />
                              </div>
                            </div>
                            <div className='platform_text_w'>
                              <strong className='pt_title'>STAR</strong>
                              <span className='pt_value'>WEBSITE</span>
                              <span className='pt_round'>
                                <span className='pt_arrow'>
                                  <svg width='10' height='6' viewBox='0 0 10 6'>
                                    <path d='M3.974,5a.822.822,0,0,1-.591-.253L-.758.461a.875.875,0,0,1,0-1.212.817.817,0,0,1,1.178,0L3.978,2.931l3.6-3.682a.817.817,0,0,1,1.179,0,.875.875,0,0,1,0,1.212L4.561,4.751A.822.822,0,0,1,3.974,5Z' transform='translate(1 1)' fill='#fff' />
                                  </svg>
                                  <i className='hide'>페이지 이동</i>
                                </span>
                              </span>
                            </div>
                          </a>
                        </Link>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>

              {/* <!-- 최신소식 --> */}
              <div className='sbsabout_main_update'>
                <div className='sbsabout_inner'>
                  <h4 className='module_title_w'>
                    <Link href='/report'>
                      <a className='module_title_link'>
                        <span className='module_title_text'>최신 소식</span>
                        <span className='svg_icon_arrow'>
                          <svg width='14.999' height='29.999' viewBox='0 0 14.999 29.999'>
                            <path d='M-11119.531-16160.5a.929.929,0,0,1-.685-.3,1.085,1.085,0,0,1,0-1.463l12.38-13.234-12.38-13.234a1.085,1.085,0,0,1,0-1.463.926.926,0,0,1,1.368,0l13.064,13.967a1.085,1.085,0,0,1,0,1.463l-13.064,13.965A.928.928,0,0,1-11119.531-16160.5Z' transform='translate(11120.499 16190.499)' fill='#fff' />
                          </svg>
                        </span>
                      </a>
                    </Link>
                  </h4>
                  <div className='update_list_w'>
                    <div className='module_thumb_list_w'>
                      <div className='module_thumb_list_swipe'>
                        <ul className='module_thumb_list_inner'>

                          {recentNewsViewData.map((item, index) => {
                            return (
                              <li key={index} className='module_thumb_list_cont'>
                                <div className='module_box_w_type2'>
                                  <a href={item.link_url} className='mb_link'>
                                    <div className='mb_image_w'>
                                      <div className='mb_image_inner'>
                                        <img src={item.img_url} className='mb_image' alt={item.title} />
                                      </div>
                                    </div>
                                    <div className='mb_info_w'>
                                      <span className='mbif_title'>{item.title}</span>
                                      {/* moment(item.reg_date).format('YYYY.MM.DD') */}
                                      <div className='mb_infoline_inner'><span className='mbif_update'>등록일</span><span className='mbif_date'>{moment(item.reg_date).format('YYYY.MM.DD')}</span></div>
                                    </div>
                                  </a>
                                </div>
                              </li>
                            );
                          })}

                        </ul>
                        {/* <!-- max 5개 --> */}
                        <ul className='slide_dots_w'>
                          {recentNewsMaxPageCount >= 1 ? (<li className={`slide_dots ${recentNews === 0 ? 'current' : ''}`}><i className='hide'>첫번째 페이지</i></li>) : (<div />)}
                          {recentNewsMaxPageCount >= 2 ? (<li className={`slide_dots ${recentNews === 1 ? 'current' : ''}`}><i className='hide'>두번째 페이지</i></li>) : (<div />)}
                          {recentNewsMaxPageCount >= 3 ? (<li className={`slide_dots ${recentNews === 2 ? 'current' : ''}`}><i className='hide'>세번째 페이지</i></li>) : (<div />)}
                          {recentNewsMaxPageCount >= 4 ? (<li className={`slide_dots ${recentNews === 3 ? 'current' : ''}`}><i className='hide'>네번째 페이지</i></li>) : (<div />)}
                          {recentNewsMaxPageCount >= 5 ? (<li className={`slide_dots ${recentNews === 4 ? 'current' : ''}`}><i className='hide'>다섯번째 페이지</i></li>) : (<div />)}
                        </ul>
                      </div>
                      {/* <!-- 4개 이하 일 경우 좌우 롤링 없으면 하단 버튼 노출없음. 맥스 카운터 해보자 --> */}
                      <button keydown={() => { setRecentNews(recentNews - 1); }} onClick={() => { setRecentNews(recentNews - 1); }} className='slide_button_prev'>
                        <span className='sb_inner'>
                          <span className='sb_paging'><i className='sbp_active'>{recentNews + 1}</i>/<i className='sbp_all'>{recentNewsMaxPageCount}</i></span>
                          <span className='sb_icon'>
                            <svg xmlns='http://www.w3.org/2000/svg' width='10' height='20' viewBox='0 0 12.414 22.828'><path d='M-11109.5-16189.5l-10,10,10,10' transform='translate(11120.5 16190.914)' /></svg>
                            <i className='hide'>이전</i>
                          </span>
                        </span>
                      </button>
                      <button keydown={() => { setRecentNews(recentNews + 1); }} onClick={() => { setRecentNews(recentNews + 1); }} className='slide_button_next'>
                        <span className='sb_inner'>
                          <span className='sb_paging'><i className='sbp_active'>{recentNews + 1}</i>/<i className='sbp_all'>{recentNewsMaxPageCount}</i></span>
                          <span className='sb_icon'>
                            <svg xmlns='http://www.w3.org/2000/svg' width='10' height='20' viewBox='0 0 12.414 22.828'><path d='M-11109.5-16189.5l-10,10,10,10' transform='translate(11120.5 16190.914)' /></svg>
                            <i className='hide'>다음</i>
                          </span>
                        </span>
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              <div className='sbsabout_main_cont07'>
                <div className='sbsabout_inner'>
                  <p className='smc_text'>
                    SBS는 한계를 뛰어넘는 도전으로<br />
                    방송산업의 패러다임을 주도하는<br />
                    No.1 콘텐츠 기업으로 나아갈 것입니다.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* <!-- 풋터 --> */}
        <MainBottom />

      </div>
    </>
  );
}

export async function getServerSideProps (ctx) {
  // header에서 meta teg에 넣어줄 데이터를 가져 오기 위함
  const { pageSection, pageCategory } = ctx.query;
  const { cookies } = ctx.req;
  const { LOGIN_JWT } = cookies;

  const jWTCheck = !!LOGIN_JWT;
  const metaTagData = getMetaTagData(ctx.req.url, pageSection, pageCategory);

  return { props: { metaTagData, jWTCheck } };
}

export default Home;
